import React from 'react';
import { testimonials } from '../data/mock';
import { Quote } from 'lucide-react';

export const Testimonials = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Loved by Communities
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Hear from people who stay connected with Fuzz
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => {
            const gradients = [
              'from-teal-500 to-emerald-500',
              'from-emerald-500 to-green-500',
              'from-green-500 to-teal-500',
              'from-blue-500 to-teal-500',
              'from-teal-500 to-cyan-500',
              'from-cyan-500 to-emerald-500'
            ];
            
            return (
              <div 
                key={index} 
                className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 hover:shadow-xl transition-all hover:-translate-y-1"
              >
                {/* Quote icon */}
                <div className={`w-12 h-12 bg-gradient-to-br ${gradients[index % gradients.length]} rounded-full flex items-center justify-center mb-6`}>
                  <Quote className="h-6 w-6 text-white" />
                </div>
                
                {/* Quote */}
                <p className="text-gray-700 text-lg leading-relaxed mb-6">
                  "{testimonial.quote}"
                </p>
                
                {/* Author */}
                <div className="border-t border-gray-200 pt-4">
                  <p className="font-semibold text-gray-900">{testimonial.author}</p>
                  <p className="text-gray-500 text-sm">{testimonial.location}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
